export default __webpack_public_path__ + "static/media/eu-flag.43061a3b.png";